import React from 'react';

export class AddressField extends React.Component {
    fieldRef = React.createRef();

    onEvent = event => {
        const { onChangeValue } = this.props;
        if (
            event.detail.event === 'validated' &&
            onChangeValue &&
            event.detail.value !== this.props.value &&
            event.detail.result
        ) {
            onChangeValue(event.detail.value);
        }
    };

    componentDidMount() {
        this.fieldRef.current.addEventListener('fieldEvent', this.onEvent);
    }

    componentWillUnmount() {
        this.fieldRef.current.removeEventListener('fieldEvent', this.onEvent);
    }

    componentDidUpdate(prevProps) {
        if (this.props.status === 'error' && this.props.status !== prevProps.status) {
            this.fieldRef.current.makeInvalid && this.fieldRef.current.makeInvalid();
        }
    }

    render() {
        const { label, id, name, value, required } = this.props;
        return (
            <flos-address-field
                label={label}
                id={id}
                name={name}
                value={value}
                is-required={required}
                ref={this.fieldRef}
            />
        );
    }
}
